module.exports = __webpack_public_path__ + "static/media/question-icon-black.8cdaf6f6.png";